import React, { useState } from 'react'
import { StyleSheet } from 'react-native'
import { DNABox } from '@alucio/lux-ui'
import { TabView, Tab } from '@ui-kitten/components'
// Tabs
import General from './Tabs/General'
import Logging from './Tabs/Logging'
import ServiceWorker from './Tabs/ServiceWorker'
import MatchSlides from './Tabs/MatchSlides'
import Search from './Tabs/Search'
import AISearchHistory from './Tabs/AISearchHistory'
import FeatureFlagsTab from './Tabs/FeatureFlags'
import MantleSummaryDebug from './Tabs/MantleSummaryDebug'
import { FeatureFlags as FeatureFlagDefinitions } from 'src/types/featureFlags'
import { useUserTenant } from 'src/state/redux/selector/user'
export const S = StyleSheet.create({
  tabView: {
    flex: 1,
  },
  tabTitle: {
    paddingVertical: 5,
  },
  tabContainer: {
    padding: 20,
  },
});

const Debug: React.FC = () => {
  const [selectedIdx, setSelectedIdx] = useState(0)
  const tenant = useUserTenant()
  const enableMantleSummaryDebug = tenant?.featureFlags?.some(({ flagId, value }) => (
    flagId === FeatureFlagDefinitions.enableMantleSummaryDebug.flag && value === true
  )) ?? false
  const tabs = [
    <Tab key="general" title="General" style={S.tabTitle}>
      <General />
    </Tab>,
    <Tab key="logging" title="Debug Tool & Logging" style={S.tabTitle}>
      <Logging />
    </Tab>,
    <Tab key="service-worker" title="Service Worker" style={S.tabTitle}>
      <ServiceWorker />
    </Tab>,
    <Tab key="match-slides" title="Match Slides" style={S.tabTitle}>
      <MatchSlides />
    </Tab>,
    <Tab key="search" title="Search" style={S.tabTitle}>
      <Search />
    </Tab>,
    <Tab key="ai-search-history" title="AI Search History" style={S.tabTitle}>
      <AISearchHistory />
    </Tab>,
    <Tab key="feature-flags" title="Feature Flags" style={S.tabTitle}>
      <FeatureFlagsTab />
    </Tab>,
  ];

  if (enableMantleSummaryDebug) {
    tabs.push(
      <Tab key="mantle-summary" title="Mantle Summary" style={S.tabTitle}>
        <MantleSummaryDebug />
      </Tab>,
    );
  }

  return (
    <DNABox>
      <TabView
        selectedIndex={selectedIdx}
        onSelect={setSelectedIdx}
        style={S.tabView}
      >
        {tabs}
      </TabView>
    </DNABox>
  )
}

export default Debug
